import { callInvitationWatermark } from "./Utils/invitationWatermarkApi";
import { invitationDeliveryView } from "./Utils/invitationDeliveryView";
const {
  getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, linkWithCredential,
  GoogleAuthProvider, signInWithPopup, signInWithCustomToken, signOut,
} = require("firebase/auth");

const { initializeApp } = require("firebase/app");
const { mergeImportedContactLists } = require("./Utils/contactImport");
const { getPhoneIdentityKey } = require("./Utils/phone");
const {
  getFirestore,
  getDoc,
  getDocs,
  doc,
  setDoc,
  collection,
  query,
  where,
  updateDoc,
  deleteField,
  runTransaction,
} = require("firebase/firestore/lite");
const { buildAutopilotPackageRemovalPatch, buildPlanEditHistory, buildRsvpAccessTransitionPatch } = require("./Utils/autopilotAdmin");

const firebaseConfig = {
  apiKey: "AIzaSyCFRG9Hzt4QaSM5jSKGbi77JU0jDog7-48",
  authDomain: "invitations778.firebaseapp.com",
  projectId: "invitations778",
  storageBucket: "invitations778.appspot.com",
  messagingSenderId: "1086400457897",
  appId: "1:1086400457897:web:a0ae55369fcaf5219e0db8",
  measurementId: "G-RLVRFXR1J5",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export const DEMO_DOCUMENT_ID = "5i74Ij5YX0YvYqFaa5O0TLareFv2";
export const DEMO_READ_ONLY_MESSAGE = "מערכת לדוגמא בלבד - לא ניתן לערוך";

export const isDemoDocument = (docID) => docID === DEMO_DOCUMENT_ID;

let lastDemoReadOnlyNotice = 0;
const blockDemoWrite = (docID) => {
  if (!isDemoDocument(docID)) return false;

  // A single UI action can call more than one persistence helper. Avoid
  // showing the same warning several times for that one attempted action.
  const now = Date.now();
  if (typeof window !== "undefined" && now - lastDemoReadOnlyNotice > 300) {
    lastDemoReadOnlyNotice = now;
    window.dispatchEvent(
      new CustomEvent("demo-read-only-attempt", {
        detail: { message: DEMO_READ_ONLY_MESSAGE },
      })
    );
  }
  return true;
};

export const createEventUser = async ({ username, password,payload }) => {
  const res = await createUserWithEmailAndPassword(auth, username, password).catch((err) => console.log(err));
  if (res) {
    let docID = res._tokenResponse.localId;
    let docsref = doc(db, "users", docID);
    await setDoc(docsref, payload).catch((err) => console.log(err));
  }
  return res;
};
export const createUser = async ({ username, password }) => {
  const res = await createUserWithEmailAndPassword(auth, username, password).catch((err) => console.log(err));
  return res;
};
export const login = async ({ username, password }) => {
  const res = await signInWithEmailAndPassword(auth, username, password).catch((err) => console.log(err));
  return res;
};

export { db, app, auth };

export const addDocumentData = async ({ docID, payload }) => {
  if (blockDemoWrite(docID)) return { blocked: true, demoReadOnly: true };
  let docsref = doc(db, "users", docID);
  const res = await updateDoc(docsref, payload).catch((err) => console.log(err));
  console.log(res);
  return res;
};
export const saveInvitationSettings = async ({ docID, patch }) => {
  if (blockDemoWrite(docID)) throw new Error(DEMO_READ_ONLY_MESSAGE);
  const ref = doc(db, "users", docID);
  const result=await runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(ref);
    if (!snapshot.exists()) throw new Error("Event document was not found.");
    const current = snapshot.data();
    if(current.invitationDelivery?.deliveryMode === "FREE_WATERMARK") return {managed:true};
    const attachment = patch["invitationData.attachmentData"];
    if (attachment && !attachment.url && (current.messages || []).some(message =>
      message.channel === "whatsapp" && !["cancelled", "error"].includes(message.status)
      && new Date(String(message.timeToSend || "").replace(" ", "T")).getTime() > Date.now())) {
      throw new Error("יש הודעות וואטסאפ מתוזמנות. לא ניתן להסיר את תמונת ההזמנה.");
    }
    transaction.update(ref, patch);
    return invitationDeliveryView({ ...current, invitationData: { ...current.invitationData, ...(attachment ? { attachmentData: attachment } : {}) },
      invitationLinkVersion: patch.invitationLinkVersion || current.invitationLinkVersion },docID);
  });
  if(result.managed){
    const idToken=await auth.currentUser?.getIdToken();if(!idToken)throw Error("AUTH_REQUIRED");
    return callInvitationWatermark({idToken,eventId:docID,action:"saveSettings",patch});
  }
  return result;
};

// Validate against the saved plan inside the write: a stale browser copy must not
// reset a Step the scheduler started after the page loaded.
export const saveAutopilotPlanEdit = async ({ docID, buildPatch, editSource }) => {
  if (blockDemoWrite(docID)) return { blocked: true, demoReadOnly: true };
  const ref = doc(db, "users", docID);
  return runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(ref);
    if (!snapshot.exists()) throw new Error("Event document was not found.");
    const current = snapshot.data();
    const patch = buildPatch({ currentPlan: current.autopilotPlan, lifecycle: current.autopilotLifecycle });
    patch.autopilotPlanEdits = buildPlanEditHistory({
      beforePlan: current.autopilotPlan, afterPlan: patch.autopilotPlan, previousEdits: current.autopilotPlanEdits, source: editSource,
    });
    transaction.update(ref, patch);
    return { patch };
  });
};

export const mergeImportedContacts = async ({ docID, contacts }) => {
  if (blockDemoWrite(docID)) throw new Error(DEMO_READ_ONLY_MESSAGE);
  const docsref = doc(db, "users", docID);

  return runTransaction(db, async (transaction) => {
    const currentDocument = await transaction.get(docsref);
    if (!currentDocument.exists()) throw new Error("Event document was not found.");

    const currentContacts = Array.isArray(currentDocument.data()?.contacts)
      ? currentDocument.data().contacts
      : [];
    const result = mergeImportedContactLists(currentContacts, contacts);
    if (result.addedCount > 0) transaction.update(docsref, { contacts: result.contacts });
    return result;
  });
};
export const loginWithGoogle = async () => signInWithPopup(auth, new GoogleAuthProvider());
export const loginWithStage5Token = async (token) => signInWithCustomToken(auth, token);
export const signOutCurrentUser = async () => signOut(auth);
export const getEventDocumentState = async (docID) => {
  const snapshot = await getDoc(doc(db, "users", docID));
  return { exists: snapshot.exists(), data: snapshot.exists() ? snapshot.data() : null };
};
export const removeAutopilotPackage = async ({ docID }) => {
  if (blockDemoWrite(docID)) return { blocked: true, demoReadOnly: true };
  const docsref = doc(db, "users", docID);
  await updateDoc(docsref, {
    ...buildAutopilotPackageRemovalPatch(deleteField()),
    rsvpAccess: deleteField(),
  });
  return { removed: true };
};

export const setRsvpAccessState = async ({ docID, currentData, classification, actor }) => {
  if (blockDemoWrite(docID)) return { blocked: true, demoReadOnly: true };
  const docsref = doc(db, "users", docID);
  const patch = buildRsvpAccessTransitionPatch({
    currentData,
    classification,
    deleteFieldValue: deleteField(),
    actor,
  });
  await updateDoc(docsref, patch);
  return { updated: true, rsvpAccess: patch.rsvpAccess };
};

const transactionError = (code, details = {}) => {
  const error = new Error(code);
  error.code = code;
  Object.assign(error, details);
  return error;
};

const findUniqueContactIndex = (contacts, phoneNumber) => {
  const phoneKey = getPhoneIdentityKey(phoneNumber);
  const matches = contacts
    .map((contact, index) => ({ contact, index }))
    .filter(({ contact }) => phoneKey && getPhoneIdentityKey(contact?.phoneNumber) === phoneKey);
  if (matches.length === 0) throw transactionError("CONTACT_NOT_FOUND");
  if (matches.length > 1) throw transactionError("CONTACT_PHONE_AMBIGUOUS");
  return matches[0].index;
};

const partySize = (contact) => {
  const parsed = parseInt(String(contact?.howMany || "1"), 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : 1;
};

const assertContactFitsAssignedTable = ({ contacts, contactIndex, contact, seatingTables }) => {
  if (!contact.tableNum) return;
  const table = seatingTables.find((item) => String(item?.id) === String(contact.tableNum));
  if (!table) throw transactionError("CONTACT_TABLE_NOT_FOUND");
  const capacity = parseInt(String(table.capacity), 10) || 0;
  const occupiedWithoutContact = contacts.reduce((sum, item, index) => (
    index !== contactIndex && String(item?.tableNum) === String(table.id) ? sum + partySize(item) : sum
  ), 0);
  const availableSeats = Math.max(capacity - occupiedWithoutContact, 0);
  const neededSeats = partySize(contact);
  if (neededSeats > availableSeats) {
    throw transactionError("CONTACT_TABLE_CAPACITY_EXCEEDED", { availableSeats, neededSeats });
  }
};

export const addContactTransactional = async ({ docID, contact }) => {
  if (blockDemoWrite(docID)) return { blocked: true, demoReadOnly: true };
  const docsref = doc(db, "users", docID);
  return runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(docsref);
    if (!snapshot.exists()) throw transactionError("EVENT_DOCUMENT_NOT_FOUND");
    const contacts = Array.isArray(snapshot.data()?.contacts) ? snapshot.data().contacts : [];
    const phoneKey = getPhoneIdentityKey(contact?.phoneNumber);
    if (!phoneKey) throw transactionError("CONTACT_PHONE_INVALID");
    if (contacts.some((item) => getPhoneIdentityKey(item?.phoneNumber) === phoneKey)) {
      throw transactionError("CONTACT_PHONE_EXISTS");
    }
    const updatedContacts = [...contacts, contact];
    transaction.update(docsref, { contacts: updatedContacts });
    return { contacts: updatedContacts, contact };
  });
};

export const deleteContactTransactional = async ({ docID, phoneNumber }) => {
  if (blockDemoWrite(docID)) return { blocked: true, demoReadOnly: true };
  const docsref = doc(db, "users", docID);
  return runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(docsref);
    if (!snapshot.exists()) throw transactionError("EVENT_DOCUMENT_NOT_FOUND");
    const contacts = Array.isArray(snapshot.data()?.contacts) ? snapshot.data().contacts : [];
    const contactIndex = findUniqueContactIndex(contacts, phoneNumber);
    const updatedContacts = contacts.filter((_, index) => index !== contactIndex);
    transaction.update(docsref, { contacts: updatedContacts });
    return { contacts: updatedContacts };
  });
};

export const updateContactTransactional = async ({ docID, phoneNumber, patch }) => {
  if (blockDemoWrite(docID)) return { blocked: true, demoReadOnly: true };
  const docsref = doc(db, "users", docID);
  return runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(docsref);
    if (!snapshot.exists()) throw transactionError("EVENT_DOCUMENT_NOT_FOUND");
    const data = snapshot.data() || {};
    const contacts = Array.isArray(data.contacts) ? data.contacts : [];
    const contactIndex = findUniqueContactIndex(contacts, phoneNumber);
    const contactPatch = { ...patch };
    delete contactPatch.whatsappRsvpProgress;
    delete contactPatch.whatsappRsvpReset;
    // This helper writes through the existing authenticated event-owner rules.
    // Only an explicit status reset starts a fresh WhatsApp confirmation cycle.
    if (contactPatch.status === "pending") {
      contactPatch.whatsappRsvpReset = {
        version: (contacts[contactIndex].whatsappRsvpReset?.version || 0) + 1,
        at: new Date().toISOString(),
      };
    }
    const updatedContact = { ...contacts[contactIndex], ...contactPatch };
    const seatingTables = Array.isArray(data.seatingTables) ? data.seatingTables : [];
    assertContactFitsAssignedTable({ contacts, contactIndex, contact: updatedContact, seatingTables });
    const updatedContacts = contacts.map((contact, index) => index === contactIndex ? updatedContact : contact);
    transaction.update(docsref, { contacts: updatedContacts });
    return { contacts: updatedContacts, contact: updatedContact };
  });
};

export const saveSeatingTableTransactional = async ({ docID, table, allowCreate = false }) => {
  if (blockDemoWrite(docID)) return { blocked: true, demoReadOnly: true };
  const docsref = doc(db, "users", docID);
  return runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(docsref);
    if (!snapshot.exists()) throw transactionError("EVENT_DOCUMENT_NOT_FOUND");
    const data = snapshot.data() || {};
    const tables = Array.isArray(data.seatingTables) ? data.seatingTables : [];
    const contacts = Array.isArray(data.contacts) ? data.contacts : [];
    const existingIndex = tables.findIndex((item) => String(item?.id) === String(table.id));
    if (existingIndex < 0 && !allowCreate) throw transactionError("SEATING_TABLE_NOT_FOUND");
    const normalizedNumber = String(table.number || "").trim();
    if (tables.some((item, index) => index !== existingIndex && String(item?.number || "").trim() === normalizedNumber)) {
      throw transactionError("SEATING_TABLE_NUMBER_EXISTS");
    }
    const capacity = parseInt(String(table.capacity), 10) || 0;
    const occupiedSeats = contacts.reduce((sum, contact) => (
      String(contact?.tableNum) === String(table.id) ? sum + partySize(contact) : sum
    ), 0);
    if (capacity < occupiedSeats) {
      throw transactionError("SEATING_TABLE_CAPACITY_EXCEEDED", { occupiedSeats });
    }
    const updatedTables = existingIndex >= 0
      ? tables.map((item, index) => index === existingIndex ? { ...item, ...table } : item)
      : [...tables, table];
    transaction.update(docsref, { seatingTables: updatedTables });
    return { tables: updatedTables };
  });
};

export const deleteSeatingTableTransactional = async ({ docID, tableId }) => {
  if (blockDemoWrite(docID)) return { blocked: true, demoReadOnly: true };
  const docsref = doc(db, "users", docID);
  return runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(docsref);
    if (!snapshot.exists()) throw transactionError("EVENT_DOCUMENT_NOT_FOUND");
    const data = snapshot.data() || {};
    const tables = Array.isArray(data.seatingTables) ? data.seatingTables : [];
    if (!tables.some((table) => String(table?.id) === String(tableId))) {
      throw transactionError("SEATING_TABLE_NOT_FOUND");
    }
    const contacts = Array.isArray(data.contacts) ? data.contacts : [];
    const updatedTables = tables.filter((table) => String(table?.id) !== String(tableId));
    const updatedContacts = contacts.map((contact) => (
      String(contact?.tableNum) === String(tableId) ? { ...contact, tableNum: "" } : contact
    ));
    transaction.update(docsref, { seatingTables: updatedTables, contacts: updatedContacts });
    return { tables: updatedTables, contacts: updatedContacts };
  });
};
export const getDocument = async ({ docID }) => {
  const res = await getDoc(doc(db,"users",docID)).catch((err)=>console.log(err));
  if(res?.exists() && res.data()?.invitationDelivery?.deliveryMode === "FREE_WATERMARK") {
    const view = invitationDeliveryView(res.data(),docID);
    return {id:res.id,ref:res.ref,exists:()=>res.exists(),data:()=>view};
  }
  return res;
};
// Written by getPublicInvitation when a guest opens one of the two share links.
export const getShareLinkViews = async ({ docID }) => {
  try {
    const snap = await getDoc(doc(db, "users", docID, "stats", "shareViews"));
    const data = snap.exists() ? snap.data() : {};
    return { rsvp: Number(data.rsvp) || 0, invite: Number(data.invite) || 0 };
  } catch (error) {
    console.log(error);
    return { rsvp: 0, invite: 0 };
  }
};
export const getDeliveryRecords = async ({ docID }) => {
  try {
    if (isDemoDocument(docID)) {
      const userSnap = await getDoc(doc(db, "users", docID));
      const contacts = Array.isArray(userSnap.data()?.contacts) ? userSnap.data().contacts : [];
      // Demo-only delivery history with varied per-guest counts. Repeating a
      // phone number represents another completed delivery in the existing UI.
      // This must stay virtual: queue documents can trigger real sends.
      const sms = [];
      const wa = [];
      contacts.forEach((contact, index) => {
        const phone = contact.phoneNumber || "";
        if (!phone) return;
        const bucket = index % 11;
        const deliveryMixes = [
          [0, 0], // untouched
          [1, 0], [2, 0], [3, 0],
          [0, 1], [0, 2], [0, 3],
          [1, 1], [1, 2], [2, 3], [3, 2],
        ];
        const [waCount, smsCount] = deliveryMixes[bucket];
        for (let count = 0; count < waCount; count += 1) wa.push(phone);
        for (let count = 0; count < smsCount; count += 1) sms.push(phone);
      });
      return { sms, wa, voice: [], skipped: [], messageResults: [] };
    }

    const [smsSnap, waSnap, skipSnap, voiceSnap] = await Promise.all([
      getDocs(query(collection(db, "smsQueue"), where("userId", "==", docID))),
      getDocs(query(collection(db, "whatsappQueue"), where("userId", "==", docID))),
      getDocs(query(collection(db, "skippedQueue"), where("userId", "==", docID))),
      getDocs(query(collection(db, "autopilotVoiceOperations"), where("eventId", "==", docID))),
    ]);
    const smsRecords = smsSnap.docs.map((document) => ({
      id: document.id,
      channel: "sms",
      ...document.data(),
    }));
    const waRecords = waSnap.docs.map((document) => ({
      id: document.id,
      channel: "whatsapp",
      ...document.data(),
    }));
    const sms = smsRecords.filter((record) => record.status === "sent").map((record) => record.phoneNumber || "");
    const wa = waRecords.filter((record) => record.status === "sent").map((record) => {
      const t = record.to || "";
      return t.startsWith("+972") ? "0" + t.slice(4) : t;
    });
    // skipped: records for contacts that were not sent because the scheduled cap was reached
    const skipped = skipSnap.docs.map(d => ({
      phoneNumber: d.data().phoneNumber || "",
      messageId: d.data().messageId || "",
      channel: d.data().channel || "sms",
      timeToSend: d.data().timeToSend || "",
      toGroup: d.data().toGroup || "",
    }));
    const messageResults = [...smsRecords, ...waRecords].map((record) => ({
      messageId: record.messageId || "",
      channel: record.channel,
      status: record.status || "pending",
      timeToSend: record.timeToSend || "",
      error: record.error || "",
      sentInvitationImageUrl: record.sentInvitationImageUrl || "",
    }));
    const voice = voiceSnap.docs.map((document) => ({
      id: document.id,
      ...document.data(),
    }));
    return { sms, wa, voice, skipped, messageResults };
  } catch (err) {
    console.log("getDeliveryRecords error:", err);
    return { sms: [], wa: [], voice: [], skipped: [], messageResults: [] };
  }
};

export const claimMessageGift = async ({ docID }) => {
  if (blockDemoWrite(docID)) return { status: "blocked" };
  if (!auth.currentUser || auth.currentUser.uid !== docID) {
    throw new Error("MESSAGE_GIFT_AUTH_REQUIRED");
  }

  const docsref = doc(db, "users", docID);
  return runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(docsref);
    if (!snapshot.exists()) throw new Error("MESSAGE_GIFT_DOCUMENT_NOT_FOUND");

    const data = snapshot.data() || {};
    const smsBalance = Math.max(0, parseInt(String(data.smsBank || "0"), 10) || 0);
    const whatsAppBalance = Math.max(0, parseInt(String(data.whatsAppBank || "0"), 10) || 0);
    const hasMessageHistory = Array.isArray(data.messages) && data.messages.length > 0;
    const adminResetAllowed = data.messageGiftAdminReset === true;

    if (data.messageGiftClaimed === true && !adminResetAllowed) return { status: "already-claimed" };
    if (smsBalance > 0 || whatsAppBalance > 0) {
      return { status: "not-eligible" };
    }
    if (!adminResetAllowed && (data.messageBankPurchased === true || hasMessageHistory)) {
      return { status: "not-eligible" };
    }

    transaction.update(docsref, {
      smsBank: 10,
      whatsAppBank: 10,
      messageGiftClaimed: true,
      messageGiftClaimedAt: new Date().toISOString(),
      messageGiftAdminReset: false,
    });

    return { status: "claimed", smsBank: 10, whatsAppBank: 10 };
  });
};
